/*****************************************************/
/* 処　理：SMS002 契約情報 画面
/*
/* 概　要：INパラメータ
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS002KeiyakuInfoInVO {

  /** 画面ID */
  screenId!: string;

}
